import { AxiosResponse } from 'axios'
import { CaseReportId, CaseReportRespType } from '../../models'
import fetch from '../fetch'

export type CaseReportGetParams = {
  id: CaseReportId
}

// TOTO by chtělo také zrefaktorovat
// TODO rename to 'getCaseReport'
export default ({
  id,
}: CaseReportGetParams): Promise<AxiosResponse<CaseReportRespType>> => {
  const token = localStorage.getItem('token')
  return fetch({
    method: 'GET',
    path: `api/v1/case-report/${id}`,
    headers: {
      Authorization: token && `Bearer ${token}`,
    },
  })
}
